import React, { useContext } from 'react';
import { Box, BoxProps, Typography } from '@mui/material';
import { UiContext } from 'shared/lib/contexts/uiContext';

export default function MenuHeader({
  text,
  ...props
}: BoxProps & { text: string }) {
  const {
    spacings: { sp },
  } = useContext(UiContext);

  return (
    <Box {...props} sx={{ p: sp.s30, ...props.sx }}>
      <Typography variant="f16" color="text.secondary">
        {text}
      </Typography>
    </Box>
  );
}
